type Props = {
  label: string;
  value: string;
  options: { label: string; value: string }[];
  onChange: (value: string) => void;
  icon?: string;
};

export default function SelectField({ label, value, options, onChange, icon }: Props) {
  return (
    <label className="flex flex-col gap-1.5 w-full md:w-auto">
      <span className="text-[11px] tracking-[0.14em] uppercase text-secondary-500 font-label">
        {label}
      </span>
      <span className="relative flex items-center">
        {icon && (
          <i
            className={`${icon} absolute left-3 w-4 h-4 flex items-center justify-center text-secondary-400 text-sm pointer-events-none`}
          ></i>
        )}
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={`appearance-none w-full md:w-[136px] h-10 ${icon ? 'pl-9' : 'pl-3'} pr-8 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-800 outline-none focus:border-primary-400 transition-colors cursor-pointer`}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <i className="ri-arrow-down-s-line absolute right-2.5 w-4 h-4 flex items-center justify-center text-secondary-400 text-base pointer-events-none"></i>
      </span>
    </label>
  );
}